import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CommunicationTemplatesQueryKeys } from "modules/CommunicationTemplates/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CommunicationMedium } from "models";

export const useUpdateMediumMutation = () =>
  useTypedMutation<CommunicationMedium, void>({
    mutationFn: async payload => (await ApiInstance.post("/communication/mediums/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const mediums = typedQueryClient.getQueryData(CommunicationTemplatesQueryKeys.getCommunicationMediums);
      if (!mediums?.length) return;

      let mediumIdx = mediums.findIndex(medium => medium.communication_medium_id === payload.communication_medium_id);

      if (mediumIdx > -1)
        return typedQueryClient.setQueryData(CommunicationTemplatesQueryKeys.getCommunicationMediums, mediums.with(mediumIdx, { ...mediums[mediumIdx], ...payload }));

      mediumIdx = mediums.findIndex(medium => medium.variations?.some(variation => variation.communication_medium_id === payload.communication_medium_id));
      if (mediumIdx < 0) return;

      const variations = mediums[mediumIdx].variations;
      if (!variations?.length) return;

      const variationIdx = variations.findIndex(variation => variation.communication_medium_id === payload.communication_medium_id);
      if (variationIdx < 0) return;

      typedQueryClient.setQueryData(
        CommunicationTemplatesQueryKeys.getCommunicationMediums,
        mediums.with(mediumIdx, {
          ...mediums[mediumIdx],
          variations: variations.with(variationIdx, { ...variations[variationIdx], ...payload })
        })
      );
    }
  });
